import React, {useEffect, useMemo, useState} from 'react';
import {
    addDays,
    eachDayOfInterval,
    endOfDay,
    endOfMonth,
    endOfWeek,
    format,
    isSunday,
    isWithinInterval,
    parse,
    parseISO,
    startOfDay,
    startOfMonth,
    startOfWeek
} from "date-fns";
import {Chart} from "react-google-charts";
import {Modal} from "react-bootstrap";
import axios from 'axios';

const Stats = ({events, setIsStat, users, apiKey}) => {
    const [weeklyEventCounts, setWeeklyEventCounts] = useState([]);
    const [monthlyEventCounts, setMonthlyEventCounts] = useState([]);

    // Day stats
    const [totalRDVDay, setTotalRDVDay] = useState(0);
    const [totalRDVDayPr, setTotalRDVDayPr] = useState(0);
    const [totalRDVDayAb, setTotalRDVDayAb] = useState(0);
    const [totalRDVDayProg, setTotalRDVDayProg] = useState(0);
    const [totalRDVDayOs, setTotalRDVDayOs] = useState(0);

    // RDV1 Day stats
    const [totalRDVDayRDV1, setTotalRDVDayRDV1] = useState(0);
    const [totalRDVDayRDV1Pr, setTotalRDVDayRDV1Pr] = useState(0);
    const [totalRDVDayRDV1Ab, setTotalRDVDayRDV1Ab] = useState(0);
    const [totalRDVDayRDV1Prog, setTotalRDDayRDV1Prog] = useState(0);
    const [totalRDVDayRDV1Visio, setTotalRDVDayRDV1Visio] = useState(0);
    const [totalRDVDayRDV1VisioPr, setTotalRDVDayRDV1VisioPr] = useState(0);
    const [totalRDVDayRDV1VisioAb, setTotalRDVDayRDV1VisioAb] = useState(0);
    const [totalRDVDayRDV1VisioProg, setTotalRDDayRDV1VisioProg] = useState(0);

    // RDV2 Day stats
    const [totalRDVDayRDV2, setTotalRDVDayRDV2] = useState(0);
    const [totalRDVDayRDV2Pr, setTotalRDVDayRDV2Pr] = useState(0);
    const [totalRDVDayRDV2Ab, setTotalRDVDayRDV2Ab] = useState(0);
    const [totalRDVDayRDV2Prog, setTotalRDDayRDV2Prog] = useState(0);

    // RDV3 Day stats - New additions
    const [totalRDVDayRDV3, setTotalRDVDayRDV3] = useState(0);
    const [totalRDVDayRDV3Pr, setTotalRDVDayRDV3Pr] = useState(0);
    const [totalRDVDayRDV3Ab, setTotalRDVDayRDV3Ab] = useState(0);
    const [totalRDVDayRDV3Prog, setTotalRDDayRDV3Prog] = useState(0);

    // Week stats
    const [totalRDVWeek, setTotalRDVWeek] = useState(0);
    const [totalRDVWeekPr, setTotalRDVWeekPr] = useState(0);
    const [totalRDVWeekAb, setTotalRDVWeekAb] = useState(0);
    const [totalRDVWeekProg, setTotalRDVWeekProg] = useState(0);
    const [totalRDVWeekOs, setTotalRDVWeekOs] = useState(0);

    // RDV1 Week stats
    const [totalRDVWeekRDV1, setTotalRDVWeekRDV1] = useState(0);
    const [totalRDVWeekRDV1Pr, setTotalRDVWeekRDV1Pr] = useState(0);
    const [totalRDVWeekRDV1Ab, setTotalRDVWeekRDV1Ab] = useState(0);
    const [totalRDVWeekRDV1Prog, setTotalRDVWeekRDV1Prog] = useState(0);
    const [totalRDVWeekRDV1Visio, setTotalRDVWeekRDV1Visio] = useState(0);
    const [totalRDVWeekRDV1VisioPr, setTotalRDVWeekRDV1VisioPr] = useState(0);
    const [totalRDVWeekRDV1VisioAb, setTotalRDVWeekRDV1VisioAb] = useState(0);
    const [totalRDVWeekRDV1VisioProg, setTotalRDVWeekRDV1VisioProg] = useState(0);

    // RDV2 Week stats
    const [totalRDVWeekRDV2, setTotalRDVWeekRDV2] = useState(0);
    const [totalRDVWeekRDV2Pr, setTotalRDVWeekRDV2Pr] = useState(0);
    const [totalRDVWeekRDV2Ab, setTotalRDVWeekRDV2Ab] = useState(0);
    const [totalRDVWeekRDV2Prog, setTotalRDVWeekRDV2Prog] = useState(0);

    // RDV3 Week stats - New additions
    const [totalRDVWeekRDV3, setTotalRDVWeekRDV3] = useState(0);
    const [totalRDVWeekRDV3Pr, setTotalRDVWeekRDV3Pr] = useState(0);
    const [totalRDVWeekRDV3Ab, setTotalRDVWeekRDV3Ab] = useState(0);
    const [totalRDVWeekRDV3Prog, setTotalRDVWeekRDV3Prog] = useState(0);

    // Month stats
    const [totalRDVMonth, setTotalRDVMonth] = useState(0);
    const [totalRDVMonthPr, setTotalRDVMonthPr] = useState(0);
    const [totalRDVMonthAb, setTotalRDVMonthAb] = useState(0);
    const [totalRDVMonthProg, setTotalRDVMonthProg] = useState(0);
    const [totalRDVMonthOs, setTotalRDVMonthOs] = useState(0);

    // RDV1 Month stats
    const [totalRDVMonthRDV1, setTotalRDVMonthRDV1] = useState(0);
    const [totalRDVMonthRDV1Pr, setTotalRDVMonthRDV1Pr] = useState(0);
    const [totalRDVMonthRDV1Ab, setTotalRDVMonthRDV1Ab] = useState(0);
    const [totalRDVMonthRDV1Prog, setTotalRDVMonthRDV1Prog] = useState(0);
    const [totalRDVMonthRDV1Visio, setTotalRDVMonthRDV1Visio] = useState(0);
    const [totalRDVMonthRDV1VisioPr, setTotalRDVMonthRDV1VisioPr] = useState(0);
    const [totalRDVMonthRDV1VisioAb, setTotalRDVMonthRDV1VisioAb] = useState(0);

    // RDV2 Month stats
    const [totalRDVMonthRDV2, setTotalRDVMonthRDV2] = useState(0);
    const [totalRDVMonthRDV2Pr, setTotalRDVMonthRDV2Pr] = useState(0);
    const [totalRDVMonthRDV2Ab, setTotalRDVMonthRDV2Ab] = useState(0);
    const [totalRDVMonthRDV2Prog, setTotalRDVMonthRDV2Prog] = useState(0);

    // RDV3 Month stats - New additions
    const [totalRDVMonthRDV3, setTotalRDVMonthRDV3] = useState(0);
    const [totalRDVMonthRDV3Pr, setTotalRDVMonthRDV3Pr] = useState(0);
    const [totalRDVMonthRDV3Ab, setTotalRDVMonthRDV3Ab] = useState(0);
    const [totalRDVMonthRDV3Prog, setTotalRDVMonthRDV3Prog] = useState(0);

    // Taux de présence
    const [tauxPresenceByUser, setTauxPresenceByUser] = useState({});
    const [tauxPresenceByUserDay, setTauxPresenceByUserDay] = useState({});

    // Leads data
    const [leadsDataDay, setLeadsDataDay] = useState({});
    const [leadsDataMonth, setLeadsDataMonth] = useState({});

    const options = users.map(title => <option key={title} value={title}>{title}</option>);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [user, setUser] = useState(users[0])

    const [listRdv1Today, setListRdv1Today] = useState([])
    const [listRdv2Today, setListRdv2Today] = useState([])
    const [listRdv3Today, setListRdv3Today] = useState([])

    const monthsInFrench = useMemo(() => [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ], []);

    // Helper function to check if event matches the user filter
    const eventMatchesUser = (event, selectedUser) => {
        if (selectedUser === 'All') return true;

        // Check if any resourceId matches the user (with or without building suffix)
        return event.resourceIds.some(resourceId => {
            // Remove building suffix (-tn or -fr) for comparison
            const baseResourceId = resourceId.replace(/-tn$|-fr$/, '');
            return baseResourceId === selectedUser;
        });
    };

    const [year, setYear] = useState(new Date().getFullYear());


    const currentMonth = new Date().getMonth();
    const [selectedMonth, setSelectedMonth] = useState(monthsInFrench[currentMonth]);
    const tod = new Date();
    const currentDay = tod.getDate();

    const getDaysInMonth = (month, year) => {
        return new Date(year, month + 1, 0).getDate();
    };

    function extractYears(events) {
        const yearRegex = /\b(202[0-9])\b/g;
        const allYears = events.flatMap(event => {
            const allText = `${event.created} ${event.start} ${event.end}`;
            return [...allText.matchAll(yearRegex)].map(match => match[0]);
        });
        return [...new Set(allYears)].sort();
    }

    const daysInCurrentMonth = Array.from(
        {length: getDaysInMonth(monthsInFrench.indexOf(selectedMonth), year)},
        (_, i) => i + 1
    );

    const [selectedDay, setSelectedDay] = useState(currentDay);


    const handleChangeYear = (event) => {
        setListRdv1Today([])
        setListRdv2Today([])
        setListRdv3Today([])
        setYear(event.target.value);
    };
    const handleChangeMonth = (event) => {
        setListRdv1Today([])
        setListRdv2Today([])
        setListRdv3Today([])
        setSelectedMonth(event.target.value);
    };
    const handleChangeDay = (event) => {
        setListRdv1Today([])
        setListRdv2Today([])
        setListRdv3Today([])
        setSelectedDay(event.target.value);
    };

    const getDayName = (dayNumber) => {
        const date = new Date(year, monthsInFrench.indexOf(selectedMonth), dayNumber);
        const options = {weekday: 'long'};
        return new Intl.DateTimeFormat('fr-FR', options).format(date);
    };

    // Function to identify RDV type (1, 2, or 3)
    const getRdvType = (event) => {
        const title = event.title.toLowerCase().replace(/\s/g, '');
        if (title.includes('rdv1')) {
            return 1;
        } else if (title.includes('rdv2')) {
            return 2;
        } else if (title.includes('rdv3')) {
            return 3;
        }
        return 0; // Unknown type
    };




    // Function to calculate taux de présence by programmed date (RDV1 only)
    const calculateTauxPresenceByCreated = (events, user, startDate, endDate) => {
        let presents = 0;
        let programmed = 0;

        events.forEach(event => {
            // Only count RDV1 appointments
            const rdvType = getRdvType(event);
            if (rdvType !== 1) {
                return;
            }

            // Check if user matches
            if (!eventMatchesUser(event, user)) {
                return;
            }

            try {
                // Count RDV1 programmed for the period (based on appointment date - event.start)
                const startEventDate = parseISO(event.start);
                if (isWithinInterval(startEventDate, {start: startDate, end: endDate})) {
                    programmed++;

                    // Count presents RDV1 in the period
                    if (event.status === 'Présent') {
                        presents++;
                    }
                }
            } catch (error) {
                // Skip events with invalid date format
                console.warn('Invalid date format for event:', event);
            }
        });

        // Calculate percentage
        const tauxPresence = programmed > 0 ? ((presents / programmed) * 100).toFixed(2) : 0;

        return {
            presents,
            created: programmed, // labeled as "created" but actually programmed
            tauxPresence
        };
    };

    // Function to calculate taux de présence (kept for backwards compatibility)
    const calculateTauxPresence = (events, user, startDate, endDate) => {
        let presents = 0;
        let programmed = 0;

        events.forEach(event => {
            const eventDate = parseISO(event.start);

            // Check if event is for the selected user and within date range
            if (eventMatchesUser(event, user) &&
                isWithinInterval(eventDate, {start: startDate, end: endDate})) {

                const status = event.status;

                // Count programmed events (all events)
                programmed++;

                // Count presents
                if (status === 'Présent') {
                    presents++;
                }
            }
        });

        // Calculate percentage
        const tauxPresence = programmed > 0 ? ((presents / programmed) * 100).toFixed(2) : 0;

        return {
            presents,
            programmed,
            tauxPresence
        };
    };

    useEffect(() => {
        const today = new Date(year, monthsInFrench.indexOf(selectedMonth), selectedDay);
        const startOfWeekDate = startOfWeek(today);
        const endOfWeekDate = endOfWeek(today);
        const startOfMonthDate = startOfMonth(new Date(year, monthsInFrench.indexOf(selectedMonth), 1)); // Start of the selected month
        const endOfMonthDate = endOfMonth(new Date(year, monthsInFrench.indexOf(selectedMonth), 1)); // End of the selected month

        const daysInCurrentWeek = eachDayOfInterval({
            start: startOfWeekDate,
            end: endOfWeekDate
        }).filter(day => !isSunday(day));

        // Weekly counter variables
        let totalSumWeek = 0;
        let totalSumWeekProg = 0;
        let totalSumWeekOs = 0;
        let totalSumWeekPr = 0;
        let totalSumWeekAb = 0;

        // RDV1 weekly counters
        let totalSumWeekRDV1 = 0;
        let totalSumWeekRDV1Prog = 0;
        let totalSumWeekRDV1Pr = 0;
        let totalSumWeekRDV1Ab = 0;
        let totalSumWeekRDV1Visio = 0;
        let totalSumWeekRDV1VisioProg = 0;
        let totalSumWeekRDV1VisioPr = 0;
        let totalSumWeekRDV1VisioAb = 0;

        // RDV2 weekly counters
        let totalSumWeekRDV2 = 0;
        let totalSumWeekRDV2Prog = 0;
        let totalSumWeekRDV2Pr = 0;
        let totalSumWeekRDV2Ab = 0;

        // RDV3 weekly counters - New addition
        let totalSumWeekRDV3 = 0;
        let totalSumWeekRDV3Prog = 0;
        let totalSumWeekRDV3Pr = 0;
        let totalSumWeekRDV3Ab = 0;

        const weeklyCounts = daysInCurrentWeek.map(day => {
            const dailyCounts = {
                day: format(day, 'EEEE dd'),
                confirmed: 0,
                absent: 0,
                reprogrammed: 0,
                reprogrammedRap: 0,
                nonConfirmed: 0,
                present: 0,
                annule: 0,
                nrp: 0,
            };

            const incrementCounts = (event, status) => {
                switch (status) {
                    case 'Confirmé':
                        dailyCounts.confirmed++;
                        break;
                    case 'Absent':
                        dailyCounts.absent++;
                        totalSumWeekAb++;

                        // Determine RDV type for absentees
                        const rdvTypeAb = getRdvType(event);
                        if (rdvTypeAb === 1) {
                            totalSumWeekRDV1Ab++;
                            if (event.title.toLowerCase().replace(/\s/g, '').includes('visio')) {
                                totalSumWeekRDV1VisioAb++;
                            }
                        } else if (rdvTypeAb === 2) {
                            totalSumWeekRDV2Ab++;
                        } else if (rdvTypeAb === 3) {
                            totalSumWeekRDV3Ab++;
                        }
                        break;

                    case 'Présent':
                        dailyCounts.present++;
                        totalSumWeekPr++;

                        // Determine RDV type for presents
                        const rdvTypePr = getRdvType(event);
                        if (rdvTypePr === 1) {
                            totalSumWeekRDV1Pr++;
                            if (event.title.toLowerCase().replace(/\s/g, '').includes('visio')) {
                                totalSumWeekRDV1VisioPr++;
                            }
                        } else if (rdvTypePr === 2) {
                            totalSumWeekRDV2Pr++;
                        } else if (rdvTypePr === 3) {
                            totalSumWeekRDV3Pr++;
                        }
                        break;

                    case 'Annulé':
                        dailyCounts.annule++;
                        break;
                    case 'Reprogrammé à rappeler':
                        dailyCounts.reprogrammedRap++;
                        break;
                    case 'Reprogrammé':
                        dailyCounts.reprogrammed++;
                        break;
                    case 'Nrp':
                        dailyCounts.nrp++;
                        break;
                    default:
                        dailyCounts.nonConfirmed++;
                        break;
                }
                totalSumWeekProg++;

                // Determine RDV type for all programmed
                const rdvTypeProg = getRdvType(event);
                if (rdvTypeProg === 1) {
                    totalSumWeekRDV1Prog++;
                } else if (rdvTypeProg === 2) {
                    totalSumWeekRDV2Prog++;
                } else if (rdvTypeProg === 3) {
                    totalSumWeekRDV3Prog++;
                }
            };

            const processEvent = (event, day) => {
                const eventDate = parseISO(event.start);
                const status = event.status;
                const OneShot = event.oneshot;

                if (isSameDay(eventDate, day)) {
                    if (OneShot) totalSumWeekOs++;
                    if (event.title.toLowerCase().replace(/\s/g, '').includes('visio')) {
                        totalSumWeekRDV1VisioProg++;
                    }
                    incrementCounts(event, status);
                }
            };

            const processCreatedEvent = (event, day) => {
                const eventDate = parseISO(event.created);

                if (isSameDay(eventDate, day)) {
                    totalSumWeek++;

                    // Determine RDV type for created events
                    const rdvType = getRdvType(event);
                    if (rdvType === 1) {
                        totalSumWeekRDV1++;
                        if (event.title.toLowerCase().replace(/\s/g, '').includes('visio')) {
                            totalSumWeekRDV1Visio++;
                        }
                    } else if (rdvType === 2) {
                        totalSumWeekRDV2++;
                    } else if (rdvType === 3) {
                        totalSumWeekRDV3++;
                    }
                }
            };

            events.forEach(event => {
                if (eventMatchesUser(event, user)) {
                    processEvent(event, day);
                    processCreatedEvent(event, day);
                }
            });

            return dailyCounts;
        });

        const filteredWeeklyCounts = weeklyCounts.filter(day => {
            return Object.values(day).some(count => count !== 0);
        });

        // Set weekly stats
        setTotalRDVWeek(totalSumWeek);
        setTotalRDVWeekProg(totalSumWeekProg);
        setTotalRDVWeekOs(totalSumWeekOs);
        setTotalRDVWeekPr(totalSumWeekPr);
        setTotalRDVWeekAb(totalSumWeekAb);

        // Set RDV1 weekly stats
        setTotalRDVWeekRDV1(totalSumWeekRDV1);
        setTotalRDVWeekRDV1Prog(totalSumWeekRDV1Prog);
        setTotalRDVWeekRDV1Pr(totalSumWeekRDV1Pr);
        setTotalRDVWeekRDV1Ab(totalSumWeekRDV1Ab);
        setTotalRDVWeekRDV1Visio(totalSumWeekRDV1Visio);
        setTotalRDVWeekRDV1VisioProg(totalSumWeekRDV1VisioProg);
        setTotalRDVWeekRDV1VisioPr(totalSumWeekRDV1VisioPr);
        setTotalRDVWeekRDV1VisioAb(totalSumWeekRDV1VisioAb);

        // Set RDV2 weekly stats
        setTotalRDVWeekRDV2(totalSumWeekRDV2);
        setTotalRDVWeekRDV2Prog(totalSumWeekRDV2Prog);
        setTotalRDVWeekRDV2Pr(totalSumWeekRDV2Pr);
        setTotalRDVWeekRDV2Ab(totalSumWeekRDV2Ab);

        // Set RDV3 weekly stats - New additions
        setTotalRDVWeekRDV3(totalSumWeekRDV3);
        setTotalRDVWeekRDV3Prog(totalSumWeekRDV3Prog);
        setTotalRDVWeekRDV3Pr(totalSumWeekRDV3Pr);
        setTotalRDVWeekRDV3Ab(totalSumWeekRDV3Ab);

        setWeeklyEventCounts(filteredWeeklyCounts);

        // Monthly data calculation for the current month
        const isEventInCurrentWeek = (event, weekStart, weekEnd) => {
            const eventDate = parseISO(event.start);
            return isWithinInterval(eventDate, {start: weekStart, end: weekEnd});
        };

        // Updated helper functions for RDV type detection
        const isEventRDV1 = (event) => {
            return event.title.toLowerCase().split('-')[0].replace(/\s/g, '').trim().replace('visio', '').includes('rdv1');
        };

        const isEventRDV2 = (event) => {
            return event.title.toLowerCase().split('-')[0].replace(/\s/g, '').trim().includes('rdv2');
        };

        const isEventRDV3 = (event) => {
            return event.title.toLowerCase().split('-')[0].replace(/\s/g, '').trim().includes('rdv3');
        };

        const isEventRDV1Visio = (event) => {
            return event.title.toLowerCase().split('-')[0].replace(/\s/g, '').trim().includes('visio');
        };

        const incrementCountBasedOnStatus = (status, rdvType, weeklyCounts, counters, isVisio) => {
            switch (status) {
                case 'Confirmé':
                    weeklyCounts.confirmed++;
                    break;
                case 'Absent':
                    weeklyCounts.absent++;
                    counters.totalAbsences++;

                    if (rdvType === 1) {
                        counters.totalRDVAbsences.RDV1++;
                        if (isVisio) counters.totalRDVAbsences.RDV1Visio++;
                    } else if (rdvType === 2) {
                        counters.totalRDVAbsences.RDV2++;
                    } else if (rdvType === 3) {
                        counters.totalRDVAbsences.RDV3++;
                    }
                    break;

                case 'Présent':
                    weeklyCounts.present++;
                    counters.totalPresents++;

                    if (rdvType === 1) {
                        counters.totalRDVPresents.RDV1++;
                        if (isVisio) counters.totalRDVPresents.RDV1Visio++;
                    } else if (rdvType === 2) {
                        counters.totalRDVPresents.RDV2++;
                    } else if (rdvType === 3) {
                        counters.totalRDVPresents.RDV3++;
                    }
                    break;

                case 'Annulé':
                    weeklyCounts.annule++;
                    break;
                case 'Reprogrammé à rappeler':
                    weeklyCounts.reprogrammedRap++;
                    break;
                case 'Reprogrammé':
                    weeklyCounts.reprogrammed++;
                    break;
                case 'Nrp':
                    weeklyCounts.nrp++;
                    break;
                default:
                    weeklyCounts.nonConfirmed++;
                    break;
            }
        };

        const addUniqueEvent = (setterFunction, event) => {
            setterFunction(prevList => {
                const eventExists = prevList.some(existingEvent => existingEvent.id === event.id);
                return eventExists ? prevList : [...prevList, event];
            });
        };

        let counters = {
            totalEvents: 0,
            totalProgressiveEvents: 0,
            totalOneShot: 0,
            totalPresents: 0,
            totalAbsences: 0,
            totalRDVCounts: {RDV1: 0, RDV2: 0, RDV3: 0, RDV1Visio: 0},
            totalRDVProgressive: {RDV1: 0, RDV2: 0, RDV3: 0},
            totalRDVPresents: {RDV1: 0, RDV2: 0, RDV3: 0, RDV1Visio: 0},
            totalRDVAbsences: {RDV1: 0, RDV2: 0, RDV3: 0, RDV1Visio: 0}
        };

        const weeksInCurrentMonth = [];
        let currentDate = startOfMonthDate;

        while (currentDate <= endOfMonthDate) {
            const weekStart = startOfWeek(currentDate, {weekStartsOn: 1});
            const weekEnd = endOfWeek(weekStart, {weekStartsOn: 1});
            weeksInCurrentMonth.push({
                start: weekStart < startOfMonthDate ? startOfMonthDate : weekStart,
                end: weekEnd > endOfMonthDate ? endOfMonthDate : weekEnd,
            });
            currentDate = addDays(weekEnd, 1);
        }

        const monthlyCounts = weeksInCurrentMonth.map(({start: weekStart, end: weekEnd}) => {
            const weeklyCounts = {
                week: `${format(weekStart, 'dd')} - ${format(weekEnd, 'dd MMM')}`,
                confirmed: 0,
                absent: 0,
                reprogrammed: 0,
                reprogrammedRap: 0,
                nonConfirmed: 0,
                present: 0,
                annule: 0,
                nrp: 0
            };

            events.forEach(event => {
                let rdvType = 0;
                if (isEventRDV1(event)) rdvType = 1;
                else if (isEventRDV2(event)) rdvType = 2;
                else if (isEventRDV3(event)) rdvType = 3;

                const OneShot = event.oneshot;
                const status = event.status;
                const isVisio = isEventRDV1Visio(event);

                if (eventMatchesUser(event, user) && isEventInCurrentWeek(event, weekStart, weekEnd)) {
                    if (OneShot) counters.totalOneShot++;
                    incrementCountBasedOnStatus(status, rdvType, weeklyCounts, counters, isVisio);

                    if (rdvType === 1) {
                        counters.totalRDVProgressive.RDV1++;
                    } else if (rdvType === 2) {
                        counters.totalRDVProgressive.RDV2++;
                    } else if (rdvType === 3) {
                        counters.totalRDVProgressive.RDV3++;
                    }

                    counters.totalProgressiveEvents++;
                }
            });

            events.forEach(event => {
                const eventDate = parseISO(event.created);
                let rdvType = 0;
                if (isEventRDV1(event)) rdvType = 1;
                else if (isEventRDV2(event)) rdvType = 2;
                else if (isEventRDV3(event)) rdvType = 3;

                const isVisio = isEventRDV1Visio(event);

                if (eventMatchesUser(event, user) && isWithinInterval(eventDate, {
                    start: weekStart,
                    end: weekEnd
                })) {
                    if (rdvType === 1) {
                        counters.totalRDVCounts.RDV1++;
                        if (isVisio) counters.totalRDVCounts.RDV1Visio++;
                    } else if (rdvType === 2) {
                        counters.totalRDVCounts.RDV2++;
                    } else if (rdvType === 3) {
                        counters.totalRDVCounts.RDV3++;
                    }
                    counters.totalEvents++;
                }
            });

            return weeklyCounts;
        });

        // Set monthly stats
        setTotalRDVMonth(counters.totalEvents);
        setTotalRDVMonthProg(counters.totalProgressiveEvents);
        setTotalRDVMonthOs(counters.totalOneShot);
        setTotalRDVMonthPr(counters.totalPresents);
        setTotalRDVMonthAb(counters.totalAbsences);

        // Set RDV1 monthly stats
        setTotalRDVMonthRDV1(counters.totalRDVCounts.RDV1);
        setTotalRDVMonthRDV1Prog(counters.totalRDVProgressive.RDV1);
        setTotalRDVMonthRDV1Pr(counters.totalRDVPresents.RDV1);
        setTotalRDVMonthRDV1Ab(counters.totalRDVAbsences.RDV1);
        setTotalRDVMonthRDV1Visio(counters.totalRDVCounts.RDV1Visio);
        setTotalRDVMonthRDV1VisioPr(counters.totalRDVPresents.RDV1Visio);
        setTotalRDVMonthRDV1VisioAb(counters.totalRDVAbsences.RDV1Visio);

        // Updates for monthly stats
        setTotalRDVMonthRDV2(counters.totalRDVCounts.RDV2);
        setTotalRDVMonthRDV2Prog(counters.totalRDVProgressive.RDV2);
        setTotalRDVMonthRDV2Pr(counters.totalRDVPresents.RDV2);
        setTotalRDVMonthRDV2Ab(counters.totalRDVAbsences.RDV2);

        // Set RDV3 monthly stats - New additions
        setTotalRDVMonthRDV3(counters.totalRDVCounts.RDV3);
        setTotalRDVMonthRDV3Prog(counters.totalRDVProgressive.RDV3);
        setTotalRDVMonthRDV3Pr(counters.totalRDVPresents.RDV3);
        setTotalRDVMonthRDV3Ab(counters.totalRDVAbsences.RDV3);

        setMonthlyEventCounts(monthlyCounts);

        // Daily stats calculation
        const todayCounts = {
            confirmed: 0,
            absent: 0,
            reprogrammed: 0,
            reprogrammedRap: 0,
            nonConfirmed: 0,
            present: 0,
            annule: 0,
            nrp: 0,
        };

        let totalSumToday = 0;
        let totalSumTodayPr = 0;
        let totalSumTodayAb = 0;
        let totalSumTodayProg = 0;
        let totalSumTodayOs = 0;

        // RDV1 daily counters
        let totalSumTodayRDV1 = 0;
        let totalSumTodayRDV1Prog = 0;
        let totalSumTodayRDV1Pr = 0;
        let totalSumTodayRDV1Ab = 0;
        let totalSumTodayRDV1Visio = 0;
        let totalSumTodayRDV1VisioPr = 0;
        let totalSumTodayRDV1VisioAb = 0;

        // RDV2 daily counters
        let totalSumTodayRDV2 = 0;
        let totalSumTodayRDV2Prog = 0;
        let totalSumTodayRDV2Pr = 0;
        let totalSumTodayRDV2Ab = 0;

        // RDV3 daily counters - New additions
        let totalSumTodayRDV3 = 0;
        let totalSumTodayRDV3Prog = 0;
        let totalSumTodayRDV3Pr = 0;
        let totalSumTodayRDV3Ab = 0;

        events.forEach(event => {
            const createdDate = parseISO(event.created);
            const startDate = parseISO(event.start);

            // Get RDV type
            let rdvType = 0;
            if (event.title.toLowerCase().replace(/\s/g, '').includes('rdv1')) {
                rdvType = 1;
            } else if (event.title.toLowerCase().replace(/\s/g, '').includes('rdv2')) {
                rdvType = 2;
            } else if (event.title.toLowerCase().replace(/\s/g, '').includes('rdv3')) {
                rdvType = 3;
            }

            const isVisio = event.title.toLowerCase().replace(/\s/g, '').includes('visio');
            const oneShot = event.oneshot;
            const status = event.status;

            if (eventMatchesUser(event, user) && (isSameDay(createdDate, today) || isSameDay(startDate, today))) {
                // Count created events for today
                if (isSameDay(createdDate, today)) {
                    if (rdvType === 1) {
                        addUniqueEvent(setListRdv1Today, event);
                        totalSumTodayRDV1++;
                        if (isVisio) totalSumTodayRDV1Visio++;
                    } else if (rdvType === 2) {
                        addUniqueEvent(setListRdv2Today, event);
                        totalSumTodayRDV2++;
                    } else if (rdvType === 3) {
                        addUniqueEvent(setListRdv3Today, event);
                        totalSumTodayRDV3++;
                    }
                    totalSumToday++;
                }

                // Count events starting today
                if (isSameDay(startDate, today)) {
                    if (oneShot) totalSumTodayOs++;

                    if (rdvType === 1) {
                        totalSumTodayRDV1Prog++;
                    } else if (rdvType === 2) {
                        totalSumTodayRDV2Prog++;
                    } else if (rdvType === 3) {
                        totalSumTodayRDV3Prog++;
                    }

                    totalSumTodayProg++;

                    // Increment status-based counts
                    switch (status) {
                        case 'Confirmé':
                            todayCounts.confirmed++;
                            break;
                        case 'Absent':
                            todayCounts.absent++;
                            totalSumTodayAb++;

                            if (rdvType === 1) {
                                totalSumTodayRDV1Ab++;
                                if (isVisio) totalSumTodayRDV1VisioAb++;
                            } else if (rdvType === 2) {
                                totalSumTodayRDV2Ab++;
                            } else if (rdvType === 3) {
                                totalSumTodayRDV3Ab++;
                            }
                            break;

                        case 'Présent':
                            todayCounts.present++;
                            totalSumTodayPr++;

                            if (rdvType === 1) {
                                totalSumTodayRDV1Pr++;
                                if (isVisio) totalSumTodayRDV1VisioPr++;
                            } else if (rdvType === 2) {
                                totalSumTodayRDV2Pr++;
                            } else if (rdvType === 3) {
                                totalSumTodayRDV3Pr++;
                            }
                            break;

                        case 'Annulé':
                            todayCounts.annule++;
                            break;
                        case 'Reprogrammé à rappeler':
                            todayCounts.reprogrammedRap++;
                            break;
                        case 'Reprogrammé':
                            todayCounts.reprogrammed++;
                            break;
                        case 'Nrp':
                            todayCounts.nrp++;
                            break;
                        default:
                            todayCounts.nonConfirmed++;
                            break;
                    }
                }
            }
        });

        // Set daily stats
        setTotalRDVDay(totalSumToday);
        setTotalRDVDayProg(totalSumTodayProg);
        setTotalRDVDayOs(totalSumTodayOs);
        setTotalRDVDayPr(totalSumTodayPr);
        setTotalRDVDayAb(totalSumTodayAb);

        // Set RDV1 daily stats
        setTotalRDVDayRDV1(totalSumTodayRDV1);
        setTotalRDDayRDV1Prog(totalSumTodayRDV1Prog);
        setTotalRDVDayRDV1Pr(totalSumTodayRDV1Pr);
        setTotalRDVDayRDV1Ab(totalSumTodayRDV1Ab);
        setTotalRDVDayRDV1Visio(totalSumTodayRDV1Visio);
        setTotalRDVDayRDV1VisioPr(totalSumTodayRDV1VisioPr);
        setTotalRDVDayRDV1VisioAb(totalSumTodayRDV1VisioAb);

        // Set RDV2 daily stats
        setTotalRDVDayRDV2(totalSumTodayRDV2);
        setTotalRDDayRDV2Prog(totalSumTodayRDV2Prog);
        setTotalRDVDayRDV2Pr(totalSumTodayRDV2Pr);
        setTotalRDVDayRDV2Ab(totalSumTodayRDV2Ab);

        // Set RDV3 daily stats - New additions
        setTotalRDVDayRDV3(totalSumTodayRDV3);
        setTotalRDDayRDV3Prog(totalSumTodayRDV3Prog);
        setTotalRDVDayRDV3Pr(totalSumTodayRDV3Pr);
        setTotalRDVDayRDV3Ab(totalSumTodayRDV3Ab);

        // Calculate taux de présence for each user for the current day (by created)
        const tauxByUserDay = {};
        const startOfToday = startOfDay(today);
        const endOfToday = endOfDay(today);

        // Calculate for each user - daily
        users.forEach(userName => {
            if (userName !== 'All') {
                const result = calculateTauxPresenceByCreated(
                    events,
                    userName,
                    startOfToday,
                    endOfToday
                );
                tauxByUserDay[userName] = result;
            }
        });

        // Calculate for all users combined - daily
        const allUsersResultDay = calculateTauxPresenceByCreated(
            events,
            'All',
            startOfToday,
            endOfToday
        );
        tauxByUserDay['All'] = allUsersResultDay;

        setTauxPresenceByUserDay(tauxByUserDay);

        // Calculate taux de présence for each user for the current month (by created)
        const tauxByUser = {};

        // Calculate for each user - monthly
        users.forEach(userName => {
            if (userName !== 'All') {
                const result = calculateTauxPresenceByCreated(
                    events,
                    userName,
                    startOfMonthDate,
                    endOfMonthDate
                );
                tauxByUser[userName] = result;
            }
        });

        // Calculate for all users combined - monthly
        const allUsersResult = calculateTauxPresenceByCreated(
            events,
            'All',
            startOfMonthDate,
            endOfMonthDate
        );
        tauxByUser['All'] = allUsersResult;

        setTauxPresenceByUser(tauxByUser);

    }, [year, monthsInFrench, selectedMonth, selectedDay, events, user, users])

    // Fetch leads and calculate prise de RDV %
    useEffect(() => {
        const fetchLeads = async () => {
            if (!apiKey) return;

            try {
                const today = new Date(year, monthsInFrench.indexOf(selectedMonth), selectedDay);
                const startOfToday = startOfDay(today);
                const endOfToday = endOfDay(today);
                const startOfMonthDate = startOfMonth(new Date(year, monthsInFrench.indexOf(selectedMonth), 1));
                const endOfMonthDate = endOfMonth(new Date(year, monthsInFrench.indexOf(selectedMonth), 1));

                // Parse leads response format: [{activity: "Total Leads: 74 | Assigned: 74 | Camille: 37 | Sophia: 37"}]
                // Aggregates all entries if multiple days are returned
                const parseLeadsResponse = (leadsResponse) => {
                    const leadsData = {};
                    if (!leadsResponse || leadsResponse.length === 0) return leadsData;

                    // Aggregate leads from all entries (for monthly data)
                    leadsResponse.forEach(entry => {
                        const activityString = entry?.activity;
                        if (!activityString) return;

                        const parts = activityString.split('|').map(p => p.trim());
                        parts.forEach(part => {
                            const match = part.match(/(.+?):\s*(\d+)/);
                            if (match) {
                                const name = match[1].trim();
                                const count = parseInt(match[2]);
                                // Skip entries like "AB", "RAP", "NRP" (status codes) and "Assigned"
                                if (!['AB', 'RAP', 'NRP', 'Total Leads', 'Assigned'].includes(name)) {
                                    // Find matching user from users array (case-insensitive match)
                                    const matchingUser = users.find(u => u.toLowerCase() === name.toLowerCase());
                                    if (matchingUser) {
                                        leadsData[matchingUser] = (leadsData[matchingUser] || 0) + count;
                                    }
                                }
                                if (name === 'Total Leads') {
                                    leadsData['All'] = (leadsData['All'] || 0) + count;
                                }
                            }
                        });
                    });

                    return leadsData;
                };

                // Fetch daily leads
                const dayResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_EVENT}/users/leads`,
                    {
                        params: {
                            date: format(today, 'yyyy-MM-dd')
                        },
                        headers: {
                            Authorization: `Bearer ${apiKey}`
                        }
                    }
                );

                // Fetch monthly leads
                const monthResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_EVENT}/users/leads`,
                    {
                        params: {
                            startDate: format(startOfMonthDate, 'yyyy-MM-dd'),
                            endDate: format(endOfMonthDate, 'yyyy-MM-dd')
                        },
                        headers: {
                            Authorization: `Bearer ${apiKey}`
                        }
                    }
                );

                // Parse leads data
                const leadsDay = parseLeadsResponse(dayResponse.data);
                const leadsMonth = parseLeadsResponse(monthResponse.data);

                // Helper function to count RDV1 programmed by user in a date range
                const countRDV1ByUser = (userName, startDate, endDate) => {
                    return events.filter(event => {
                        const rdvType = getRdvType(event);
                        if (rdvType !== 1) return false;

                        try {
                            const startEventDate = parseISO(event.start);
                            const inRange = isWithinInterval(startEventDate, {start: startDate, end: endDate});

                            return inRange && eventMatchesUser(event, userName);
                        } catch (error) {
                            return false;
                        }
                    }).length;
                };

                // Calculate prise de RDV % for day
                const priseDay = {};
                Object.keys(leadsDay).forEach(userName => {
                    const userLeads = leadsDay[userName];
                    const userRDV = countRDV1ByUser(userName, startOfToday, endOfToday);
                    const percentage = userLeads > 0 ? ((userRDV / userLeads) * 100).toFixed(2) : 0;
                    priseDay[userName] = {
                        leads: userLeads,
                        rdv: userRDV,
                        percentage
                    };
                });

                setLeadsDataDay(priseDay);

                // Calculate prise de RDV % for month
                const priseMonth = {};
                Object.keys(leadsMonth).forEach(userName => {
                    const userLeads = leadsMonth[userName];
                    const userRDV = countRDV1ByUser(userName, startOfMonthDate, endOfMonthDate);
                    const percentage = userLeads > 0 ? ((userRDV / userLeads) * 100).toFixed(2) : 0;
                    priseMonth[userName] = {
                        leads: userLeads,
                        rdv: userRDV,
                        percentage
                    };
                });

                setLeadsDataMonth(priseMonth);

            } catch (error) {
                console.error('Error fetching leads:', error);
            }
        };

        fetchLeads();
    }, [year, selectedMonth, selectedDay, monthsInFrench, apiKey, users, events]);

    const weeklyChartData = [
        ['Day', 'Confirmé', 'Absent', 'Présent', 'Annulé', 'Reprogrammé à rappeler', 'Reprogrammé', 'Non confirmé', 'Nrp'],
        ...weeklyEventCounts.map(day => [
            day.day,
            day.confirmed,
            day.absent,
            day.present,
            day.annule,
            day.reprogrammedRap,
            day.reprogrammed,
            day.nonConfirmed,
            day.nrp

        ])
    ];
    const monthlyChartData = [
        ['Day', 'Confirmé', 'Absent', 'Présent', 'Annulé', 'Reprogrammé à rappeler', 'Reprogrammé', 'Non confirmé', 'Nrp'],
        ...monthlyEventCounts.map(week => [
            week.week,
            week.confirmed,
            week.absent,
            week.present,
            week.annule,
            week.reprogrammedRap,
            week.reprogrammed,
            week.nonConfirmed,
            week.nrp

        ])
    ];
    const isSameDay = (date1, date2) => {
        return date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear();
    };

    const goBackCalendar = () => {
        setIsStat(false)
    }
    const handleChange = (e) => {
        setUser(e.target.value);
    };
    const handleChartSelect = ({chartWrapper}) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();

        if (selection.length === 1) {
            const {row, column} = selection[0];
            const clickedDay = weeklyChartData[row + 1][0];
            const clickedStatus = weeklyChartData[0][column];

            const filteredEvents = events.filter(event => {
                const eventDate = parseISO(event.start);
                const eventDay = format(eventDate, 'EEEE dd');
                const status = event.status
                return eventDay === clickedDay && status === clickedStatus;
            });
            setSelectedEvent(filteredEvents)
            setModalShow(true)
        }
    };
    const handleChartSelectM = ({chartWrapper}) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length === 1) {
            const {row, column} = selection[0];
            const clickedDateRange = monthlyChartData[row + 1][0];
            const clickedStatus = monthlyChartData[0][column];
            const [startDateStr, endDateStr] = clickedDateRange.split(' - ');
            const endDate = parse(endDateStr, 'dd MMM', new Date());
            const startDate = parse(`${startDateStr} ${format(endDate, 'MMM')}`, 'dd MMM', new Date());
            const filteredEvents = events.filter(event => {
                const eventDate = parseISO(event.start);
                const status = event.status
                return isWithinInterval(eventDate, {start: startDate, end: endDate}) && status === clickedStatus;
            });

            setSelectedEvent(filteredEvents);
            setModalShow(true);
        }
    };
    const handleCloseModal = () => {
        setModalShow(false); // Hide the modal
        setSelectedEvent(null)


    };

    const handleShowModal = (list) => {
        if (list.length > 0) {
            setSelectedEvent(list)
            setModalShow(true);
        }

    };


    return (
        <div className={" py-6"}>

            <div className={"container "}>
                <div className={'row'}>
                    <div className="col mt-1">
                        <button className="fc-button fc-button-primary" onClick={goBackCalendar} style={{

                            borderTopLeftRadius: "0.25em",
                            borderBottomLeftRadius: "0.25em"
                        }}><i className="bi bi-back"></i></button>
                        <select className='fc-button fc-button-primary' onChange={handleChangeYear} value={year}
                                style={{
                                    padding: "0.43em 0em",
                                }}>
                            {extractYears(events).map((yearX, index) => (
                                <option key={index} value={yearX}>{yearX}</option>
                            ))}
                        </select>
                        <select className='fc-button fc-button-primary' onChange={handleChangeMonth}
                                value={selectedMonth} style={{
                            padding: "0.43em 0em",
                        }}>
                            {monthsInFrench.map((month, index) => (
                                <option key={index} value={month}>{month}</option>
                            ))}
                        </select>
                        <select className='fc-button fc-button-primary' onChange={handleChangeDay}
                                value={selectedDay} style={{
                            padding: "0.43em 0em",
                        }}>
                            {daysInCurrentMonth.map((day, index) => {
                                const dayName = getDayName(day); // Get the day name
                                return (
                                    <option key={index} value={day}>
                                        {`${dayName.charAt(0).toUpperCase() + dayName.slice(1, 3)} ${day}`}
                                    </option>
                                );
                            })}
                        </select>

                        <select className='fc-button fc-button-primary' onChange={handleChange} style={{
                            padding: "0.43em 0.5vh",
                            borderTopRightRadius: "0.25em",
                            borderBottomRightRadius: "0.25em"
                        }}>
                            {options}
                        </select>
                    </div>
                </div>
            </div>

            <div className={"container "}>
                <div className={'row'}>
                    <div className="col-12 col-md-6 col-lg-3 mt-1">
                        <div className="card">
                            <div className="card-body p-2">
                                <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                    <tr>
                                        <th style={{fontSize: '0.875rem'}}>Créé</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV1</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV2</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV3</th>
                                        <th style={{fontSize: '0.875rem'}}>OS</th>
                                        <th style={{fontSize: '0.875rem'}}>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Jour</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none"
                                                onClick={() => handleShowModal(listRdv1Today)}
                                                style={{color: 'inherit', fontSize: 'inherit'}}
                                            >
                                                {totalRDVDayRDV1}({totalRDVDayRDV1Visio})
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none"
                                                onClick={() => handleShowModal(listRdv2Today)}
                                                style={{color: 'inherit', fontSize: 'inherit'}}
                                            >
                                                {totalRDVDayRDV2}
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none"
                                                onClick={() => handleShowModal(listRdv3Today)}
                                                style={{color: 'inherit', fontSize: 'inherit'}}
                                            >
                                                {totalRDVDayRDV3}
                                            </button>
                                        </td>
                                        <td>{totalRDVDayOs}</td>
                                        <td>{totalRDVDay}</td>
                                    </tr>
                                    <tr>
                                        <td>Semaine</td>
                                        <td>{totalRDVWeekRDV1}({totalRDVWeekRDV1Visio})</td>
                                        <td>{totalRDVWeekRDV2}</td>
                                        <td>{totalRDVWeekRDV3}</td>
                                        <td>{totalRDVWeekOs}</td>
                                        <td>{totalRDVWeek}</td>
                                    </tr>
                                    <tr>
                                        <td>Mois</td>
                                        <td>{totalRDVMonthRDV1}({totalRDVMonthRDV1Visio})</td>
                                        <td>{totalRDVMonthRDV2}</td>
                                        <td>{totalRDVMonthRDV3}</td>
                                        <td>{totalRDVMonthOs}</td>
                                        <td>{totalRDVMonth}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 mt-1">
                        <div className="card">
                            <div className="card-body p-2">
                                <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                    <tr>
                                        <th style={{fontSize: '0.875rem'}}>Programmé</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV1</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV2</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV3</th>
                                        <th style={{fontSize: '0.875rem'}}>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Jour</td>
                                        <td>{totalRDVDayRDV1Prog}</td>
                                        <td>{totalRDVDayRDV2Prog}</td>
                                        <td>{totalRDVDayRDV3Prog}</td>
                                        <td>{totalRDVDayProg}</td>
                                    </tr>
                                    <tr>
                                        <td>Semaine</td>
                                        <td>{totalRDVWeekRDV1Prog}</td>
                                        <td>{totalRDVWeekRDV2Prog}</td>
                                        <td>{totalRDVWeekRDV3Prog}</td>
                                        <td>{totalRDVWeekProg}</td>
                                    </tr>
                                    <tr>
                                        <td>Mois</td>
                                        <td>{totalRDVMonthRDV1Prog}</td>
                                        <td>{totalRDVMonthRDV2Prog}</td>
                                        <td>{totalRDVMonthRDV3Prog}</td>
                                        <td>{totalRDVMonthProg}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mt-1">
                        <div className="card">
                            <div className="card-body p-2">
                                <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                    <tr>
                                        <th style={{fontSize: '0.875rem'}}>Présent</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV1</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV2</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV3</th>
                                        <th style={{fontSize: '0.875rem'}}>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Jour</td>
                                        <td>{totalRDVDayRDV1Pr} ({totalRDVDayRDV1VisioPr})</td>
                                        <td>{totalRDVDayRDV2Pr}</td>
                                        <td>{totalRDVDayRDV3Pr}</td>
                                        <td>{totalRDVDayPr}</td>
                                    </tr>
                                    <tr>
                                        <td>Semaine</td>
                                        <td>{totalRDVWeekRDV1Pr} ({totalRDVWeekRDV1VisioPr})</td>
                                        <td>{totalRDVWeekRDV2Pr}</td>
                                        <td>{totalRDVWeekRDV3Pr}</td>
                                        <td>{totalRDVWeekPr}</td>
                                    </tr>
                                    <tr>
                                        <td>Mois</td>
                                        <td>{totalRDVMonthRDV1Pr} ({totalRDVMonthRDV1VisioPr})</td>
                                        <td>{totalRDVMonthRDV2Pr}</td>
                                        <td>{totalRDVMonthRDV3Pr}</td>
                                        <td>{totalRDVMonthPr}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mt-1">
                        <div className="card">
                            <div className="card-body p-2">
                                <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead>
                                    <tr>
                                        <th style={{fontSize: '0.875rem'}}>Absent</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV1</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV2</th>
                                        <th style={{fontSize: '0.875rem'}}>RDV3</th>
                                        <th style={{fontSize: '0.875rem'}}>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Jour</td>
                                        <td>{totalRDVDayRDV1Ab} {/*({totalRDVDayRDV1VisioAb})*/}</td>
                                        <td>{totalRDVDayRDV2Ab}</td>
                                        <td>{totalRDVDayRDV3Ab}</td>
                                        <td>{totalRDVDayAb}</td>
                                    </tr>
                                    <tr>
                                        <td>Semaine</td>
                                        <td>{totalRDVWeekRDV1Ab} {/*({totalRDVWeekRDV1VisioAb})*/}</td>
                                        <td>{totalRDVWeekRDV2Ab}</td>
                                        <td>{totalRDVWeekRDV3Ab}</td>
                                        <td>{totalRDVWeekAb}</td>
                                    </tr>
                                    <tr>
                                        <td>Mois</td>
                                        <td>{totalRDVMonthRDV1Ab} {/*({totalRDVMonthRDV1VisioAb})*/}</td>
                                        <td>{totalRDVMonthRDV2Ab}</td>
                                        <td>{totalRDVMonthRDV3Ab}</td>
                                        <td>{totalRDVMonthAb}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4">
                        <div className="card">
                            <div className="card-header">
                                <h5>Taux de Présence RDV1 - {getDayName(selectedDay)} {selectedDay} {selectedMonth} {year}</h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                    <tr>
                                        <th style={{minWidth: '100px'}}>Utilisateur</th>
                                        <th style={{minWidth: '90px'}}>RDV1 Créés</th>
                                        <th style={{minWidth: '80px'}}>Présents</th>
                                        <th style={{minWidth: '100px'}}>Taux Présence</th>
                                        <th style={{minWidth: '80px'}}>Total Leads</th>
                                        <th style={{minWidth: '100px'}}>Prise RDV %</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {Object.entries(tauxPresenceByUserDay)
                                        .filter(([userName, data]) => {
                                            const leadsData = leadsDataDay[userName];
                                            // Filter out users with 0 created unless they have leads or it's "All"
                                            if (userName !== 'All' && data.created === 0 && (!leadsData || leadsData.leads === 0)) {
                                                return false;
                                            }
                                            if (user === 'All') return true; // show all users
                                            return userName === user; // show only selected user
                                        })
                                        .sort((a, b) => {
                                            if (a[0] === 'All') return 1;
                                            if (b[0] === 'All') return -1;
                                            return a[0].localeCompare(b[0]);
                                        })
                                        .map(([userName, data]) => {
                                            const leadsData = leadsDataDay[userName];
                                            return (
                                            <tr
                                                key={userName}
                                                className={userName === 'All' ? 'table-primary fw-bold' : ''}
                                            >
                                                <td>{userName}</td>
                                                <td>{data.created}</td>
                                                <td>{data.presents}</td>
                                                <td>
                        <span
                            className={`badge ${
                                data.tauxPresence >= 80
                                    ? 'bg-success'
                                    : data.tauxPresence >= 60
                                        ? 'bg-warning'
                                        : 'bg-danger'
                            }`}
                        >
                            {data.tauxPresence}%
                        </span>
                                                </td>
                                                <td>{leadsData ? leadsData.leads : '-'}</td>
                                                <td>
                                                    {leadsData ? (
                        <span
                            className={`badge ${
                                leadsData.percentage >= 80
                                    ? 'bg-success'
                                    : leadsData.percentage >= 60
                                        ? 'bg-warning'
                                        : 'bg-danger'
                            }`}
                        >
                            {leadsData.percentage}%
                        </span>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                        )})}

                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4">
                        <div className="card">
                            <div className="card-header">
                                <h5>Taux de Présence RDV1 - {selectedMonth} {year}</h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                    <tr>
                                        <th style={{minWidth: '100px'}}>Utilisateur</th>
                                        <th style={{minWidth: '90px'}}>RDV1 Créés</th>
                                        <th style={{minWidth: '80px'}}>Présents</th>
                                        <th style={{minWidth: '100px'}}>Taux Présence</th>
                                        <th style={{minWidth: '80px'}}>Total Leads</th>
                                        <th style={{minWidth: '100px'}}>Prise RDV %</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {Object.entries(tauxPresenceByUser)
                                        .filter(([userName, data]) => {
                                            const leadsData = leadsDataMonth[userName];
                                            // Filter out users with 0 created unless they have leads or it's "All"
                                            if (userName !== 'All' && data.created === 0 && (!leadsData || leadsData.leads === 0)) {
                                                return false;
                                            }
                                            if (user === 'All') return true; // show all users
                                            return userName === user; // show only selected user
                                        })
                                        .sort((a, b) => {
                                            if (a[0] === 'All') return 1;
                                            if (b[0] === 'All') return -1;
                                            return a[0].localeCompare(b[0]);
                                        })
                                        .map(([userName, data]) => {
                                            const leadsData = leadsDataMonth[userName];
                                            return (
                                            <tr
                                                key={userName}
                                                className={userName === 'All' ? 'table-primary fw-bold' : ''}
                                            >
                                                <td>{userName}</td>
                                                <td>{data.created}</td>
                                                <td>{data.presents}</td>
                                                <td>
                        <span
                            className={`badge ${
                                data.tauxPresence >= 80
                                    ? 'bg-success'
                                    : data.tauxPresence >= 60
                                        ? 'bg-warning'
                                        : 'bg-danger'
                            }`}
                        >
                            {data.tauxPresence}%
                        </span>
                                                </td>
                                                <td>{leadsData ? leadsData.leads : '-'}</td>
                                                <td>
                                                    {leadsData ? (
                        <span
                            className={`badge ${
                                leadsData.percentage >= 80
                                    ? 'bg-success'
                                    : leadsData.percentage >= 60
                                        ? 'bg-warning'
                                        : 'bg-danger'
                            }`}
                        >
                            {leadsData.percentage}%
                        </span>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                        )})}

                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Chart
                    className={'mt-4'}
                    width={'100%'}
                    height={'300px'}
                    chartType="Bar"
                    loader={<div>Loading Chart...</div>}
                    data={weeklyChartData}
                    options={{
                        chart: {
                            title: `Weekly RDV (${totalRDVWeek})`,
                        },
                        bars: 'vertical',
                        bar: {groupWidth: '70%'}, // Adjust bar width here
                        annotations: {
                            textStyle: {
                                fontSize: 12,
                                bold: true,
                                italic: false,
                                color: '#000',
                            },
                            alwaysOutside: true, // Ensure annotations are always outside the bar
                        },
                        legend: {position: 'none'},

                        colors: ['#FFC300', '#C0392B', '#28A745', '#343A40', '#8E44AD', '#007BFF', '#8B4513', '#A9A9A9'],
                    }}
                    chartEvents={[
                        {
                            eventName: 'select',
                            callback: handleChartSelect,

                        },
                    ]}

                />

                <Chart
                    chartType="Bar"
                    width={'100%'}
                    height={'400px'}
                    loader={<div>Loading Chart...</div>}
                    data={monthlyChartData}
                    options={{
                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'top',
                                formatter: (value, context) => {
                                    return value; // Display the value on top of each bar
                                },
                            },
                        },
                        chart: {
                            title: `Monthly RDV (${totalRDVMonth})`,
                        },
                        bars: 'vertical',
                        bar: {groupWidth: '70%'}, // Adjust bar width here
                        annotations: {
                            textStyle: {
                                fontSize: 12,
                                bold: true,
                                italic: false,
                                color: '#000',
                            },
                            alwaysOutside: true, // Ensure annotations are always outside the bar
                        },
                        legend: {position: 'none'},
                        colors: ['#FFC300', '#C0392B', '#28A745', '#343A40', '#8E44AD', '#007BFF', '#8B4513', '#A9A9A9'],

                    }}
                    chartEvents={[
                        {
                            eventName: 'select',
                            callback: handleChartSelectM,

                        },
                    ]}
                />

                {selectedEvent && (
                    <Modal show={modalShow} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body>
                            <ul className="list-group list-group-flush">
                                {selectedEvent
                                    .sort((a, b) => new Date(b.created) - new Date(a.created))
                                    .map((selectEV, index) => (
                                        <li className="list-group-item d-flex justify-content-between align-items-center"
                                            key={selectEV.id}>
                                            <span className="badge bg-secondary mx-2">{index + 1}</span>

                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href={selectEV.objectId
                                                    ? `https://app-eu1.hubspot.com/contacts/146139336/record/0-1/${selectEV.objectId}`
                                                    : `https://app-eu1.hubspot.com/contacts/146139336/record/0-1/${selectEV.email}`}
                                                className="text-decoration-none flex-grow-1">
                                                {selectEV.title} - {selectEV.phone}
                                            </a>
                                        </li>
                                    ))}
                            </ul>
                        </Modal.Body>
                    </Modal>
                )}


            </div>
        </div>
    );
};

export default Stats;
